import { render } from "./OrderAlerts.vue?vue&type=template&id=a2a2737e"
import script from "./OrderAlerts.vue?vue&type=script&lang=js"
export * from "./OrderAlerts.vue?vue&type=script&lang=js"

import exportComponent from "/Users/marc.bush/Sites/ensotyres/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__